import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";
import BookListDetail from "../component/BookListDetail";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class CategoryView extends Component {
	render() {
		return (
			<React.Fragment>
				<Header />

				<div className="section">
					<div className="section-header">
						<h2 className="section-title">
							<Link path="/">"엄마를 부탁해" 검색결과</Link>
						</h2>
						<p className="section-description">236건의 책이 있습니다.</p>
					</div>
					<div className="section-body">
						<div className="filterList-container">
							<div className="filterList">
								<a className="filterList-item">
									오디오북<small>(213)</small>
								</a>
								<a className="filterList-item">
									전자책<small>(23)</small>
								</a>
							</div>
							<div className="filterList">
								<a className="filterList-item">
									소설<small>(37)</small>
								</a>
								<a className="filterList-item">
									시<small>(183)</small>
								</a>
								<a className="filterList-item">
									에세이<small>(71)</small>
								</a>
								<a className="filterList-item">
									교양<small>(37)</small>
								</a>
								<a className="filterList-item">
									역사<small>(183)</small>
								</a>
								<a className="filterList-item">
									자기계발<small>(71)</small>
								</a>
							</div>
						</div>
					</div>
					<div className="section-body">
						<BookListDetail />
					</div>
				</div>

				<BottomNav />
			</React.Fragment>
		);
	}
}

export default CategoryView;
